import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Col, Container, Row, CardBody, CardTitle, CardText, CardSubtitle } from "reactstrap";
import Card from "components/PurpleTheme/Card";
import { Link, useLocation } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux

const MSTeams = props => {

    //meta title
    document.title = "MSTeams Onboarding | Temperstack";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Row>
                        <Col lg="9">
                            <Breadcrumbs
                                title={props.t("Integrate MS Teams")}
                                breadcrumbItem={props.t("Integrate MS Teams")}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Card>
                            <CardBody>
                                <CardTitle tag="h4" className="mb-4">Integration with MS Teams</CardTitle>
                                <CardText>
                                    <ol>
                                        <li>
                                            <CardSubtitle tag="h6" className="mb-2">Install the Temperstack App in MS Teams</CardSubtitle>
                                            <CardText style={{ paddingBottom: '25px' }}>You can find the Temperstack App in the MS Teams App Store.</CardText>
                                        </li>
                                        <li>
                                            <CardSubtitle tag="h6" className="mb-2">Select the MS Team Channel to install the app too</CardSubtitle>
                                            <CardText style={{ paddingBottom: '25px' }}>Click on the Temperstack app in the MS Teams App Store and then select Add To Team. Select
                                                the respective Team Channel you want to recieve Temperstack app notification.</CardText>
                                        </li>
                                        <li>
                                            <CardSubtitle tag="h6" className="mb-2">Authorize Temperstack to send notification to MS Teams</CardSubtitle>
                                            <CardText style={{ paddingBottom: '25px' }}>On the welcome message by the Temperstack Bot in the integrated team channel click on Authorize Temperstack
                                            </CardText>
                                        </li>
                                        <li>
                                            <CardSubtitle tag="h6" className="mb-2">On being redirected to Temperstack, Login and click on Authorize</CardSubtitle>
                                            <CardText style={{ paddingBottom: '25px' }}>This will link your MS Teams account with Temperstack.</CardText>
                                        </li>
                                        <li>
                                            <CardSubtitle tag="h6" className="mb-2">Then go to Temperstack Notification > Temperstack Services and edit a service and select the Team name</CardSubtitle>
                                            <CardText style={{ paddingBottom: '25px' }}>This will allow the service to send notifications to the selected MS Teams channel.</CardText>
                                        </li>
                                    </ol>
                                </CardText>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

MSTeams.propTypes = {
    t: PropTypes.any,
    chartsData: PropTypes.any,
    onGetChartsData: PropTypes.func,
};

export default withTranslation()(MSTeams);
